import * as React from "react"
import { connect } from "react-redux"
import { XBlockProps } from "react-xmasonry"

import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"
import { workspaceUrl } from "../../../util/UrlGenerator"
import env from "../../../env"

import ContentWidgetBase from "../../common/grid/widgets/ContentWidgetBase"
import ContentWidgetListItem from "../../common/grid/widgets/ContentWidgetListItem"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { IWorkspacesInfo } from "../index"

const applicationPath = env.applicationPath

interface OwnProps extends XBlockProps {
    loadMoreLabel: string
    placeholderLabel: string
    title: string
}

type StateProps = IWorkspacesInfo

type Props = OwnProps & StateProps & DispatchProps

export class Workspaces extends React.Component<Props> {
    render(): JSX.Element {
        const {
            workspaces,
            filter,
            hasMore,
            isLoading,
            noWorkspacesMessage,
            loadMoreLabel,
            placeholderLabel,
            title,
        } = this.props

        return (
            <ContentWidgetBase
                filter={filter}
                hasMore={hasMore}
                isLoading={isLoading}
                loadMoreLabel={loadMoreLabel}
                noResults={noWorkspacesMessage}
                title={title}
                loadMore={this.loadMore}
                updateFilter={this.updateFilter}
                isInverted={true}
                placeholder={placeholderLabel}
            >
                {workspaces &&
                    workspaces.map((workspace) => (
                        <ContentWidgetListItem
                            title={workspace.Label}
                            url={workspaceUrl(applicationPath, workspace)}
                            key={workspace.Id}
                            icon={Symbols.Workspace}
                        />
                    ))}
            </ContentWidgetBase>
        )
    }

    loadMore = (): void => {
        const { filter, requestWorkspaces, offset, limit } = this.props
        requestWorkspaces(filter, offset + limit, limit)
    }

    updateFilter = (newFilter: string): void => {
        const { filter, requestWorkspaces, limit } = this.props

        if (newFilter !== filter) {
            requestWorkspaces(newFilter, 0, limit)
        }
    }
}

const mapStateToProps = (state: GlobalState): StateProps =>
    state.welcomePage.workspacesInfo

export default connect(mapStateToProps, mapDispatchToProps)(Workspaces)
